import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * Created by Liu.Jun on 2019/9/29 19:01.
 */

import defaultValue from '../notice/defaultValue';
var View = function View() {
  return import('./View.vue');
};
var Form = function Form() {
  return import('../notice/Form');
};
export default {
  View: View,
  Form: Form,
  defaultValue: defaultValue
};